// Import from NPM
// -------------------------------------
import React from "react";
import { NavLink } from "react-router-dom";
import _ from "lodash";
import { Div, Image } from "@components/Generics.react";
import "@styles/navbars.scss";

import { useTranslation } from "react-i18next";
import { settings } from "@config/settings/app.settings";

export default function QuickLinks(props) {
    const { vertical = false } = props;
    const { t } = useTranslation("common");

    // ========================= Render Function =================================
    return (
        <Div className={`quick-menu ${vertical && "vertical"}`}>
            {_.map(settings.menu.quick, (quicklink, index) => {
                return (
                    <NavLink
                        key={`quick-menu-link-${index}`}
                        to={quicklink.link}
                        className="quick-link"
                    >
                        <Image
                            src={t(`sidebar.quick.${quicklink.transCode}`)}
                        />
                    </NavLink>
                );
            })}
        </Div>
    );
}
